<template>
  <div
    id="logindia"
    class="mt-5 p-3 mb-5 rounded"
    @blur="onblur()"
    @mouseenter="onmouseenter"
    @mouseleave="onmouseout"
    tabindex="500"
  >
    <!-- word-wrap: break-word:单词换行 -->
    <h1 class="h5 mb-5" style="word-wrap: break-word">
      {{ $t("loginmessage.title") }}
    </h1>
    <p class="errmessage mb-2" style="text-align: center" v-if="passwderror">
      {{ $t("loginmessage.passwderr") }}
    </p>
    <div class="form-floating col-sm-12 mt-3">
      <input
        type="text"
        class="form-control"
        id="floatingInput"
        placeholder="Username"
        v-model="name"
      />
      <label for="floatingInput">{{ $t("loginmessage.username") }}</label>
    </div>
    <div class="form-floating col-sm-12 mt-3 mb-3">
      <input
        type="password"
        class="form-control"
        id="floatingPassword"
        placeholder="Password"
        v-model="passwd"
      />
      <label for="floatingPassword">{{ $t("loginmessage.passwd") }}</label>
    </div>
    <!-- 用户点击登录 -->
    <button
      type="button"
      class="col-md-12 mb-4 btn-rounded"
      @click="onlogin"
      :class="[buttonenableflag ? activeclass : inactiveclass]"
      :disabled="buttonenableflag"
    >
      <i class="bi bi-person-check-fill"></i>
      {{ $t("loginmessage.loginbutton") }}
    </button>

    <a class="col-sm-5 mb-3" href="#regist" @click="onblur('sign up')">{{
      $t("loginmessage.signup")
    }}</a>
    <a
      class="col-sm-5 mb-3 offset-2"
      href="#forgotpassword"
      @click="onblur('forgot passwd')"
      >{{ $t("loginmessage.fpasswd") }}</a
    >
    <el-row
      ><div
        class="stitle mt-2 mx-2"
        :title="$t('loginmessage.usernotice')"
      >
        {{$t("loginmessage.aboutuser")}}
      </div></el-row
    >

    <!-- <p class="mt-5 mb-3 text-muted">&copy; 2017–2021</p> -->
  </div>
</template>

<script type="text/javascript">
import { reactive, computed, toRefs, onMounted } from "vue";
import { ElMessage } from "element-plus";
import { login } from "../../js/userhandler";
import { des } from "../../js/des";
import { useI18n } from "vue-i18n";

//import {useStore} from "vuex";

export default {
  name: "login",

  setup(props, { emit }) {
    const state = reactive({
      name: "",
      passwd: "",
      passwderror: false,
      activeclass: "btn-light",
      inactiveclass: "btn-primary",
      mouseout: true,
    });
    const { t } = useI18n();
    onMounted(() => {
      document.getElementById("logindia").focus();
      console.log(t);
    });

    const buttonenableflag = computed(() => {
      if (state.name === "" || state.passwd === "") return true;
      else return false;
    });

    const onlogin = () => {
      let username = state.name;
      let passwd = des("tuiguang", state.passwd, 1, 0);
      login(username, passwd)
        .then((res) => {
          if (res.status == 200) {
            if (res.data.status == "1") {
              emit("loginok", username);
              emit("logindiablur", "");
              ElMessage.success({ message: t("loginmessage.loginsuccess") });
            } else {
              state.passwderror = true;
            }
          }
        })
        .catch(function (error) {
          ElMessage.error({ message: error });
        });
    };

    function onblur(sender) {
      if (state.mouseout) emit("logindiablur", "");

      if (sender != undefined) emit("logindiablur", "");
    }
    function onmouseout() {
      state.mouseout = true;
    }
    function onmouseenter() {
      document.getElementById("logindia").focus();
      state.mouseout = false;
    }
    return {
      onlogin,
      ...toRefs(state),
      buttonenableflag,
      onblur,
      onmouseout,
      onmouseenter,
    };
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style  scoped>
.errmessage {
  color: red;
}
a {
  text-decoration: none;
  font: 1em sans-serif;
  color: black;
  font-weight: bold;
}
#logindia {
  box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.7);
}

.stitle {
  font-size: 0.6em;
  color: rgb(67, 154, 235);
}
</style>